import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

export default function Login() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bem-vindo, ${user.name}!`);
      navigate(user.role === 'super_admin' ? '/admin' : '/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Credenciais inválidas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#F8FAFC' }}>
      <div style={{ background:'#fff',borderRadius:20,padding:'40px 36px',width:'100%',maxWidth:420,boxShadow:'0 4px 24px rgba(0,0,0,.08)' }}>
        <div style={{ textAlign:'center',marginBottom:32 }}>
          <div style={{ fontSize:'2.5rem',marginBottom:8 }}>🚗</div>
          <h1 style={{ fontSize:'1.6rem',fontWeight:900,color:'#0F172A' }}>AutoFlow</h1>
          <p style={{ color:'#6B7280',fontSize:'.9rem' }}>Acesse sua conta</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block',fontWeight:600,fontSize:'.85rem',marginBottom:6,color:'#374151' }}>E-mail</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required
              style={{ width:'100%',padding:'10px 14px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:'1rem',outline:'none',boxSizing:'border-box' }}
              placeholder="voce@email.com" />
          </div>

          <div style={{ marginBottom:24 }}>
            <label style={{ display:'block',fontWeight:600,fontSize:'.85rem',marginBottom:6,color:'#374151' }}>Senha</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required
              style={{ width:'100%',padding:'10px 14px',border:'1.5px solid #E5E7EB',borderRadius:8,fontSize:'1rem',outline:'none',boxSizing:'border-box' }}
              placeholder="••••••••" />
          </div>

          <button type="submit" disabled={loading}
            style={{ width:'100%',padding:'12px',background:'#2563EB',color:'#fff',border:'none',borderRadius:10,
              fontSize:'1rem',fontWeight:700,cursor:loading?'not-allowed':'pointer',opacity:loading?.7:1 }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <p style={{ textAlign:'center',marginTop:24,fontSize:'.85rem',color:'#6B7280' }}>
          Não tem conta?{' '}
          <Link to="/cadastro" style={{ color:'#2563EB',fontWeight:600,textDecoration:'none' }}>Criar conta grátis</Link>
        </p>
        <p style={{ textAlign:'center',marginTop:8,fontSize:'.85rem' }}>
          <a href="#" style={{ color:'#6B7280',textDecoration:'none' }}>Esqueci minha senha</a>
        </p>
      </div>
    </div>
  );
}
